import { Box, Flex } from '@rebass/grid/emotion'
import { DefaultButton } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

export interface NormalFormFooterProps {
  cancelText?: string | any
  onCancelClick: () => void
}

export const NormalFormFooter: React.FunctionComponent<
  NormalFormFooterProps
> = (props) => {
  const { t } = useTranslation()

  return (
    <Flex justifyContent="flex-end">
      <Box px={1}>
        <DefaultButton onClick={props.onCancelClick}>
          {props.cancelText || t('action.ready')}
        </DefaultButton>
      </Box>
    </Flex>
  )
}

export default NormalFormFooter
